// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/_css-loader@3.4.0@css-loader/dist/cjs.js!../../node_modules/_stylus-loader@3.0.2@stylus-loader/index.js!./icons.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/_vue-style-loader@4.1.2@vue-style-loader/lib/addStylesClient.js").default
var update = add("f7f20048", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons.styl
// module id = 9
// module chunks = 0